module.exports = __webpack_public_path__ + "static/media/3898426d-c647-47c8-9e02-98650e2e6691.63ac1fd1.JPG";